import locales from './locales'

const nameCities = {
	SAO_PAULO: 'São Paulo',
	BELO_HORIZONTE: 'Belo Horizonte',
	RIO_DE_JANEIRO: 'Rio de Janeiro',
	RECIFE: 'Recife',
	GOIANIA: 'Goiânia',
	PORTO_ALEGRE: 'Porto Alegre',
	FLORIANOPOLIS: 'Florianópolis',
	SALVADOR: 'Salvador',
	CAMPINAS: 'Campinas',
	BRASILIA: 'Brasília',
	CURITIBA: 'Curitiba',
	FORTALEZA: 'Fortaleza',
}

const getSections = (lang: 'en' | 'pt' | 'es' = 'pt') => [
	{
		key: 1,
		title: locales[lang]['CITIES'],
		options: [
			{
				name: nameCities['SAO_PAULO'],
				link: 'https://www.sympla.com.br/eventos/sao-paulo-sp',
			},
			{
				name: nameCities['BELO_HORIZONTE'],
				link: 'https://www.sympla.com.br/eventos/belo-horizonte-mg',
			},
			{
				name: nameCities['RIO_DE_JANEIRO'],
				link: 'https://www.sympla.com.br/eventos/rio-de-janeiro-rj',
			},
			{
				name: nameCities['PORTO_ALEGRE'],
				link: 'https://www.sympla.com.br/eventos/porto-alegre-rs',
			},
			{
				name: nameCities['BRASILIA'],
				link: 'https://www.sympla.com.br/eventos/brasilia-df',
			},
			{
				name: nameCities['SALVADOR'],
				link: 'https://www.sympla.com.br/eventos/salvador-ba',
			},
			{
				name: nameCities['CURITIBA'],
				link: 'https://www.sympla.com.br/eventos/curitiba-pr',
			},
			{
				name: nameCities['RECIFE'],
				link: 'https://www.sympla.com.br/eventos/recife-pe',
			},
			{
				name: nameCities['FLORIANOPOLIS'],
				link: '/eventos/florianopolis-sc',
			},
			{
				name: nameCities['CAMPINAS'],
				link: 'https://www.sympla.com.br/eventos/campinas-sp',
			},
			{
				name: nameCities['FORTALEZA'],
				link: 'https://www.sympla.com.br/eventos/fortaleza-ce',
			},
			{
				name: nameCities['GOIANIA'],
				link: 'https://www.sympla.com.br/eventos/goiania-go',
			},
		],
	},
	{
		key: 2,
		title: locales[lang]['CATEGORIES'],
		options: [
			{
				name: locales[lang]['SYMPLA_PLAY'],
				link: 'https://www.sympla.com.br/eventos/sympla-play',
			},
			{
				name: locales[lang]['PARTIES_SHOWS'],
				link: 'https://www.sympla.com.br/eventos/show-musica-festa',
			},
			{
				name: locales[lang]['THEATER_SHOW'],
				link: 'https://www.sympla.com.br/eventos/teatro-espetaculo',
			},
			{
				name: locales[lang]['COURSES_WORKSHOPS'],
				link: 'https://www.sympla.com.br/eventos/curso-workshop',
			},
			{
				name: locales[lang]['CONGRESSES_TALK'],
				link: 'https://www.sympla.com.br/eventos/congresso-palestra',
			},
			{
				name: locales[lang]['SPORT'],
				link: 'https://www.sympla.com.br/eventos/esportivo',
			},
			{
				name: locales[lang]['TOURS'],
				link: 'https://www.sympla.com.br/eventos/experiencias',
			},
			{
				name: locales[lang]['GASTRONOMY'],
				link: 'https://www.sympla.com.br/eventos/gastronomico',
			},
			{
				name: locales[lang]['FREE'],
				link: 'https://www.sympla.com.br/eventos/gratis',
			},
			{
				name: locales[lang]['HEALTH_WELFARE'],
				link: 'https://www.sympla.com.br/eventos/saude-e-bem-estar',
			},
			{
				name: locales[lang]['ART_CULTURE_LEISURE'],
				link: 'https://www.sympla.com.br/eventos/arte-e-cultura',
			},
			{
				name: locales[lang]['KID'],
				link: 'https://www.sympla.com.br/eventos/infantil',
			},
			{
				name: locales[lang]['RELIGION_SPIRITUALITY'],
				link: '/eventos/religioso-espiritual',
			},
			{
				name: locales[lang]['GAMES_GEEK'],
				link: 'https://www.sympla.com.br/eventos/games-e-geek',
			},
			// { 'name': locales[lang]['REVEILLON'], 'link': '/eventos/reveillon' },
			{
				name: locales[lang]['FASHION_BEAUTY'],
				link: 'https://www.sympla.com.br/eventos/moda-e-beleza',
			},
		],
	},
	{
		key: 3,
		title: locales[lang]['ORGANIZERS'],
		options: [
			{
				name: locales[lang]['HOW_IT_WORKS'],
				link: 'https://produtores.sympla.com.br/como-funciona/?__hstc=181257784.4c8872a436f9b62d2c86b808b91d0200.1743089752561.1743641669755.1743686280316.15&__hssc=181257784.1.1743686280316&__hsfp=3072090281&_gl=1*1xjzuke*_gcl_au*NjY1OTU4OTgxLjE3NDMwODk3NTI.*_ga*MzE4NDkzNTgwLjE3NDMwODk3NTI.*_ga_KXH10SQTZF*MTc0MzY4NjI3OC4xMy4wLjE3NDM2ODYyODAuNTguMC4xMjUxMTY0NzEw',
			},
			{
				name: locales[lang]['CREATE_YOUR_EVENT'],
				link: 'https://www.sympla.com.br/solucoes',
			},
			{
				name: locales[lang]['EVENT_TYPES'],
				link: 'https://produtores.sympla.com.br/tipos-de-eventos/',
			},
			{
				name: locales[lang]['SOLUTIONS'],
				link: 'https://www.sympla.com.br/solucoes',
			},
			{
				name: locales[lang]['SUCCESSFULL_CASES'],
				link: 'https://blog.sympla.com.br/blog-do-produtor/funcionalidades-sympla/cases-de-sucesso/',
			},
			{
				name: locales[lang]['SPEAK_TO_A_CONSULTANT'],
				link: 'https://www.sympla.com.br/fale-com-um-consultor?ca=footer',
			},
			{
				name: locales[lang]['HOMOLOGATED'],
				link: 'https://www.sympla.com.br/conecta',
			},
			{
				name: locales[lang]['API'],
				link: 'https://developers.sympla.com.br/api-doc/index.html',
			},
			{
				name: locales[lang]['SECURE_EVENT'],
				link: 'https://produtores.sympla.com.br/funcionalidades/evento-seguro/',
			},
		],
	},
	{
		key: 4,
		title: locales[lang]['THE_SYMPLA'],
		options: [
			{
				name: locales[lang]['ABOUT'],
				link: '/',
			},
			{
				name: locales[lang]['JOBS'],
				link: '/',
			},
			{
				name: locales[lang]['BLOG'],
				link: '/',
			},
		],
	},
	{
		key: 5,
		title: locales[lang]['HELP'],
		options: [
			{
				name: locales[lang]['HELP_CENTER'],
				link: 'https://ajuda.sympla.com.br/hc/pt-br/',
			},
			{
				name: locales[lang]['BUYERS'],
				link: 'https://ajuda.sympla.com.br/hc/pt-br/?_gl=1*863e6l*_gcl_au*NjY1OTU4OTgxLjE3NDMwODk3NTI.*_ga*MzE4NDkzNTgwLjE3NDMwODk3NTI.*_ga_KXH10SQTZF*MTc0MzY4NjI3OC4xMy4xLjE3NDM2ODY3MzEuMzEuMC4xMjUxMTY0NzEw',
			},
			{
				name: locales[lang]['PRODUCERS'],
				link: 'https://symplaprodutor.zendesk.com/hc/pt-br',
			},
		],
	},
]

export default getSections
